<template>
  <el-card>
    <el-form label-width="auto">
      <el-form-item :label="$t('名称')">
        <span>{{ detailInfo.name || "" }}</span>
      </el-form-item>

      <el-form-item :label="$t('内容')" class="rich-text-row">
        <div class="content" v-html="detailInfo.content"></div>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import {request} from "@/config/request";

export default {
  name: "RichTextDetail",
  data() {
    return {
      detailInfo: {}
    }
  },
  methods: {
    async loadDetail() {
      try {
        const res = await request(this.$api.richText.detail, this.$route.query);
        this.detailInfo = res.richText;
      } catch (e) {
        console.log(e);
      }
    }
  },
  created() {
    this.loadDetail();
  }
}
</script>

<style scoped>

.el-form {
  max-width: 400px;
}

.rich-text-row {
  width: 900px;
}


.content {
  width: 100%;
  height: 600px;
  overflow-y: auto;
  border: 1px solid #DCDFE6;
  box-sizing: border-box;
  padding: 4px;
  border-radius: 4px;
}

</style>
